<template>
    <div class="dot-wrapper" v-if="hasDot">
        <div 
            class="dot-item"
            v-for="(item) in itemLen"
        >
            <a
                href="javascript:;"
                class="dot-lk"
                :style="{backgroundColor:(item - 1) === currentIndex ? dotBgColor : '#fff'}"
                @click="dotClick(item-1)"
            ></a>
        </div>
    </div>
  </template>

<script>
export default{
    name:'swiperDot',
    props:{
        itemLen:Number,
        currentIndex:Number,
        hasDot:{
            type:Boolean,
            default:true
        },
        dotBgColor:{
            type:String,
            default:'#ff5000'
        }
    },
    methods:{
        // 点击指示点
        dotClick(index){
            let direction = "next"
            // 判断点击的指示点是在当前滑块指示点前面还是后面
            if(index < this.currentIndex){
                direction = "prev"
            }
            this.$emit('dotClick',index,direction)
        }
    }
}
</script>

<style lang="scss" scoped>
.dot-wrapper{
    height: 13px;
    border-radius: 10px;
    position: absolute;
    bottom: 15px;
    text-align: center;
    left: 50%;
    z-index: 1;
    margin-left: -39px;
    background-color: rgba(255, 255, 255, .3);
    .dot-item{
        display: inline-block;
        margin: 3px;

        .dot-lk{
            display: block;
            padding-top: 8px;
            width: 8px;
            height: 0;
            border-radius: 50%;
            background: #fff;
        }
    }
}
</style>